import React from 'react';
import clsx from 'clsx';

import { NavButton as StyledNavButton } from './wrappers';
import { ChevronLeftIcon, ChevronRightIcon } from '../Icon';

interface INavButton {
  onClick: () => void;
  title?: string;
  dir: 'prev' | 'next';
  theme?: 'dark' | 'light';
}

const NavButton = ({ onClick, title, dir, theme = 'dark' }: INavButton) => (
  <StyledNavButton
    onClick={onClick}
    title={title ? title : dir === 'prev' ? 'Föregående' : 'Nästa'}
    className={clsx(theme === 'light' && 'theme-light')}
    type="button">
    {dir === 'prev' && <ChevronLeftIcon strokeWidth="2" />}
    {dir === 'next' && <ChevronRightIcon strokeWidth="2" />}
  </StyledNavButton>
);

export default NavButton;
